// extracted by mini-css-extract-plugin
export var actionIcon = "_sa-0";